import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC, useEffect, useState } from "react";
import SearchForm from "../../SearchForm/SearchForm";
import { Route, Switch, useHistory } from "react-router-dom";
import { BreadcrumbsItem, BreadcrumbsWrapper } from "@sainsburys-tech/luna-breadcrumbs";
import { initialValueOfProductModel } from "../../../Models/ProductModel";
import ProductQuery from "../Query/query";
import ProductAttributes from "../Attributes/attributes";
import ProductMeasurementsClothing from "../Measurements-clothing/measurementsClothing";
import ProductMeasurements from "../Measurements/measurements";
import ProductHierarchy from "../Hierarchy/hierarchy";
import { storeFilter } from "../../../Redux/Actions/filterActions";
import store from "../../../Store/store";
import { useSelector } from "react-redux";
import { filterPayloadType } from "../../../Types/filterPayloadType";
import DataTable from "./DataTable/DataTable";
import { ValuesType } from "../../../Types/InitialStateType";
import ProductMenu from "../Product-Menu/productMenu";

const ProductSearch: FC = (props) => {
  const [dataTablePayload, setDataTablePayload] = useState();
  const history = useHistory();

  const {
    data,
    isDirectQuery,
    parentName,
    selectedMenu,
    searchId,
    description,
    searchPageReset,
    createPopupName,
    deletePopupName,
  } = useSelector((state: any) => state.filterReducer.data);
  const menuHeader = useSelector((state: any) => state.menuHeaderReducer.data);
  const payload = useSelector((state: any) => state.dataTableReducer);
  const nonDirectQueryRespnse = useSelector(
    (state: any) => state.menuHeaderReducer?.data
  );

  useEffect(() => {
    setDataTablePayload(payload);
  }, []);

  let searchPayload: ValuesType[] = [
    {
      name: "Search",
      label: "Search",
      value: "",
      searchMethod: "contains",
      searchOperator: "or",
    },
  ];

  const initialState = {
    values: searchPayload,
    submitted: false,
    dirty: false,
  };
  const [disableSearchForm, setDisableSearchForm] = useState(false);
  const toggleSearch = (isDisabled: boolean) => {
    setDisableSearchForm(isDisabled);
  };

  const onClick = () => {
    let data: filterPayloadType = {
      data: "",
      isDirectQuery: true,
      codeScreen: "Search 75",
      parentName: "/familyGroupAdmin",
      selectedMenu: "Summary",
      createPopupName: undefined,
      deletePopupName: undefined,
      description: undefined,
      nestedSearchId: undefined,
      previousParentName: undefined,
      previousQueryData: undefined,
      searchId: undefined,
      searchPageReset: undefined,
    };
    store.dispatch(storeFilter(data));
    history.push("/familyGroupAdmin/summary", { HeaderName: "Summary" });
  };

  const breadcrumMessage = (searchId: string, description: string): string => {
    if (searchId === "" || searchId === null || searchId === undefined) {
      return "Not Assigned";
    }
    return `${searchId}`;
  };
  return (
    <>
      <Container className="containerPanelFullHeight" soft data-test="add">
        {isDirectQuery || menuHeader?.isDirectQuery ? (
          <>
            <h4 style={{ display: "inline" }}>Product</h4>{" "}
            <span className="orangeSainsburysAction">
              | {nonDirectQueryRespnse && nonDirectQueryRespnse.selectedMenu
                ? `${nonDirectQueryRespnse.selectedMenu}`
                : `${selectedMenu}`}
            </span>
          </>
        ) : (
          <BreadcrumbsWrapper>
            <BreadcrumbsItem>
              <a href="javascript:void(0)" onClick={onClick}>
                Family Group Admin
              </a>
            </BreadcrumbsItem>
            <BreadcrumbsItem>
              <a href="javascript:void(0)" onClick={onClick}>
                Summary
              </a>
            </BreadcrumbsItem>
            <BreadcrumbsItem>
              <a href="javascript:void(0)" onClick={onClick}>
                Product
              </a>
            </BreadcrumbsItem>
            <BreadcrumbsItem active>
              {nonDirectQueryRespnse && nonDirectQueryRespnse.selectedMenu
                ? `${nonDirectQueryRespnse.selectedMenu}`
                : `${selectedMenu}`}
            </BreadcrumbsItem>
          </BreadcrumbsWrapper>
        )}

        {(!isDirectQuery && !menuHeader?.isDirectQuery) &&
          <div className="ln-heading">
            <div className="ln-dropdown">{nonDirectQueryRespnse?.selectedMenu ?? selectedMenu}</div>
            <div className="ln-product-menu"><ProductMenu showBackBtn={false} /></div>
          </div>
        }

        <SearchForm
          initialState={initialState}
          isDisabled={disableSearchForm}
          model={initialValueOfProductModel}
        />
        <Switch>
          <Route exact path={`/product/query`}>
            <ProductQuery toggleSearchPanel={toggleSearch} />
          </Route>
          <Route path={`/product/attributes`}>
            <ProductAttributes toggleSearchPanel={toggleSearch} />
          </Route>
          <Route path={`/product/measurementsClothing`}>
            <ProductMeasurementsClothing toggleSearchPanel={toggleSearch} />
          </Route>
          <Route exact path={`/product/measurements`}>
            <ProductMeasurements toggleSearchPanel={toggleSearch} />
          </Route>
          <Route exact path={`/product/hierarchy`}>
            <ProductHierarchy toggleSearchPanel={toggleSearch} />
          </Route>
          <Route exact path={`/product`}>
            <ProductQuery toggleSearchPanel={toggleSearch} />
          </Route>
        </Switch>
        {dataTablePayload && (
          <Container
            className="gridContainer containerPanelFullWidthWithWhiteBKG"
            soft
          >
            <DataTable
              service={payload.data.service}
              columnDefinition={payload.data.columnDefinition}
              toggleSearchPanel={payload.data.toggleSearchPanel}
              isColumnMerge={payload.data.isColumnMerge}
            />
          </Container>
        )}
      </Container>
    </>
  );
};

export default ProductSearch;
